import React, { Component } from 'react';
import './testimonial.css'


class Testimonial extends Component {
    constructor(props) {
        super(props)

    }
    render() {

        return (
            <div className='Testimonial'  >
                <div className='TesttimonialChild1'>
                    <div className='TestsubChild1'>
                        <div className='TestsubChild1HeadChild'>
                            <p>WHAT PEOPLE SAY ABOUT ME</p>
                        </div>

                    </div>
                    <div className='TestsubChild1'>
                        <div className='TestsubChild11'>
                            <img src={require('../../images/hamzah.png')} alt="Avatar" class="AvatarDiv" />

                            <div className='QuoteDiv'>
                                <p>His work is awesome and to the point. His ability to understand the requirements of the client is very powerful.  He has the potential to convert the idea to reality. I must recommend to everyone who is in need of an expert and an educated Web developer.</p>
                                <h2>Hamzah Imtiaz</h2>
                                <h3>Client</h3>
                            </div>

                        </div>
                        <div className='TestsubChild12'>
                            <img src={require('../../images/hamzah.png')} alt="Avatar" class="AvatarDiv" />

                            <div className='QuoteDiv'>
                                <p>His work is awesome and to the point. His ability to understand the requirements of the client is very powerful.  He has the potential to convert the idea to reality. I must recommend to everyone who is in need of an expert and an educated Web developer.</p>
                                <h2>Hamzah Imtiaz</h2>
                                <h3>Client</h3>
                            </div>

                        </div>
                    </div>
                    <div className='TestsubChild1'>
                        <div className='TestsubChild11'>
                            <img src={require('../../images/hamzah.png')} alt="Avatar" class="AvatarDiv" />

                            <div className='QuoteDiv'>
                                <p>His work is awesome and to the point. His ability to understand the requirements of the client is very powerful.  He has the potential to convert the idea to reality. I must recommend to everyone who is in need of an expert and an educated Web developer.</p>
                                <h2>Hamzah Imtiaz</h2>
                                <h3>Client</h3>
                            </div>
                        </div>
                        <div className='TestsubChild12'>
                            <img src={require('../../images/hamzah.png')} alt="Avatar" class="AvatarDiv" />

                            <div className='QuoteDiv'>
                                <p>His work is awesome and to the point. His ability to understand the requirements of the client is very powerful.  He has the potential to convert the idea to reality. I must recommend to everyone who is in need of an expert and an educated Web developer.</p>
                                <h2>Hamzah Imtiaz</h2>
                                <h3>Client</h3>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Testimonial;



// WEBPACK FOOTER //
// ./src/containers/testimonial/testimonial.js